module.exports = __webpack_public_path__ + "static/media/ico_escudo-vivo.5d64d2da.svg";